import React from 'react';
import {
  Nav, Navbar, NavDropdown, NavItem,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ReactComponent as Settings } from '../../assets/svg/settings.svg';

const logout = () => {
  localStorage.removeItem('token');
  window.location.reload();
};

export default function Menu() {
  return (
    <div>
      <Navbar
        collapseOnSelect
        expand="lg"
      >
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <NavDropdown style={{ paddingRight: document.body.clientWidth > 990 ? 20 : 0 }} title="Add" id="nav-dropdown1">
              <NavDropdown.Item eventKey="1.1" as={Link} to="/new-lead">New lead</NavDropdown.Item>
              <NavDropdown.Item eventKey="1.3" as={Link} to="/new-upwork-proposal-lead">New Upwork.Proposal lead</NavDropdown.Item>
              <NavDropdown.Item eventKey="1.2" as={Link} to="/new-plan">New plan</NavDropdown.Item>            </NavDropdown>
            <NavDropdown style={{ paddingRight: document.body.clientWidth > 990 ? 20 : 0 }} title="Leads" id="nav-dropdown2">
              <NavDropdown.Item eventKey="3.1" as={Link} to="/lead-list">List</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown style={{ paddingRight: document.body.clientWidth > 990 ? 20 : 0 }} title="Dashboards" id="nav-dropdown2">
              <NavDropdown.Item eventKey="5.1" as={Link} to="/dashboard-by-funnels">By Funnels</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown style={{ paddingRight: document.body.clientWidth > 990 ? 20 : 0 }} title="Plans" id="nav-dropdown4">
              <NavDropdown.Item eventKey="4.1" as={Link} to="/plans-list">List</NavDropdown.Item>
            </NavDropdown>
            <NavItem>
              <Nav.Link eventKey="link-1" as={Link} to="/developers-availability">Developers Availability</Nav.Link>
            </NavItem>
          </Nav>
          <Nav>
            <NavDropdown
              style={{ paddingRight: document.body.clientWidth > 990 ? 20 : 0 }}
              title={(
                <p>
                  <Settings
                    width={17}
                    height={17}
                    style={{
                      marginRight: 7, fill: 'rgba(0,0,0,.5)', position: 'relative', top: -1,
                    }}
                  />
									Settings
                </p>
							)}
              className="nav-dropdown3"
              id="nav-dropdown3"
            >
              <NavDropdown.Item eventKey="2.4" onClick={() => logout()} as={Link} to="/">Logout</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}
